<div id="complete-profile-page" class="container-expanded bg-complete-profile">
    <div class="page-content section-profile">
        <!-- <app-page-title [pageTitle]="'page.complete-profile.title' | translate">
        </app-page-title> -->
        <div class="row m--0">

            <div
                class="col-12 col-lg-6 col-lg-offset-6 column gap-16 align-items-center justify-centent-center bg-white">
                <mat-card class="p--24 form-cart mat-elevation-z0">
                    <mat-card-header>
                        <mat-card-title>{{'page.complete_profile.title' | translate}}</mat-card-title>
                        <mat-card-subtitle
                            [innerHTML]="'page.complete_profile.subtitle' | translate"></mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <form [formGroup]="completeProfileForm">
                            <mat-form-field>
                                <mat-label>Nome</mat-label>
                                <input matInput formControlName="name">
                                <mat-error *ngIf="completeProfileForm.controls['name']?.invalid">{{'field-required' | translate}}</mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Cognome</mat-label>
                                <input matInput formControlName="surname">
                                <mat-error *ngIf="completeProfileForm.controls['surname']?.invalid">{{'field-required' | translate}}</mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Telefono</mat-label>
                                <input matInput formControlName="phone">
                                <mat-error *ngIf="completeProfileForm.controls['phone']?.invalid">{{'field-required' | translate}}</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Sito Web</mat-label>
                                <input matInput formControlName="website">
                            </mat-form-field>
                            <div class="tec">
                                <mat-checkbox formControlName='privacy'>Autorizzo al trattamento dei dati</mat-checkbox>
                                <mat-checkbox formControlName='tec'>Accetto i <span class="text-underline text-primary">Termini e Condizioni</span> di utilizzo dei servizi di Delfi.ai</mat-checkbox>
                            </div>
                            <div class="actions">
                                <button class="fw p--24" mat-flat-button color="primary" (click)="submitForm()"
                                    [disabled]="!completeProfileForm.valid">{{ 'Salva' | translate }}</button>
                                    <mat-divider class="mt--24 mb--8"></mat-divider>
                                <button class="fw p--24" mat-button  (click)="forceLogout()">{{ 'Esci e torna in home' | translate }}</button>
                            </div>
            
            </form>
            </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
</div>